/** The read-only sheets behind the heading's menu, and the `?panel=` values that open them. ActiveCampaign reconciliation went to Settings → Data and sync with the sync (#716). */

export const PANELS = [
  { key: "readiness", label: "Audience readiness" },
  { key: "engagement", label: "Engagement data" },
] as const;

export type PanelKey = (typeof PANELS)[number]["key"];

export const isPanel = (value: string | null): value is PanelKey => PANELS.some((panel) => panel.key === value);
